export default __webpack_public_path__ + "static/media/image 7.0da07c20.png";